import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const ITEMS = ['Los 6 Tomos de la Ruta Clínica para el Manejo de la Obesidad.', 'Más de 300 algoritmos, protocolos, tablas y herramientas organizadas para resolver las decisiones más importantes de la consulta.', 'Checklists de evaluación, prescripción y seguimiento para estandarizar tu práctica clínica.', 'Recursos educativos listos para entregar al paciente y mejorar la adherencia al tratamiento.', 'Material descargable en formato PDF, optimizado para computadora, tablet y teléfono móvil.'];
export function WhatYouGet() {
  return <section className="w-full bg-cream px-4 py-14" data-id="element-265" data-mp="141xg267zgj1i">
      <div className="mx-auto max-w-2xl" data-id="element-266" data-mp="190sbq8r1u231">
        <h2 className="text-center font-display text-[26px] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-267" data-mp="18zh603e1mk9a">
          ¿Qué recibirás inmediatamente después de comprar?
        </h2>

        <ul className="mt-8 space-y-3" data-id="element-268" data-mp="21icwkpmu22bj">
          {ITEMS.map(item => <li key={item} className="flex gap-3 rounded-2xl border border-navy-100 bg-white p-4 shadow-sm" data-id="element-269" data-mp="2vf10lou1lgay">
              <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-green-600" aria-hidden="true" data-id="element-270" data-mp="2qemre3gpg0bc" />
              <span className="text-[14px] leading-relaxed text-navy/80 sm:text-[15px]" data-id="element-271" data-mp="30ene7zds8yka">{item}</span>
            </li>)}
        </ul>

        <div className="mt-9 flex justify-center" data-id="element-272" data-mp="3e8end6nlqgfh">
          <CTAButton label="QUIERO RECIBIRLO TODO HOY" sublabel="Recibes el acceso por correo en minutos" pulse={false} data-id="element-273" data-mp="3980anbb22ib4" />
        </div>
      </div>
    </section>;
}